import persistSlice from './slice';

export const persistActions = {
  ...persistSlice.actions,
  // INJECT
};
